module.exports = __webpack_public_path__ + "static/media/om_eyeshape_round_lightbrown.0af191b6.png";